import { inject, Injectable } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import type { Observable } from 'rxjs';

import { IS_SERVER_TOKEN } from '@app/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class OnlyServerGuard {
  readonly #isServer = inject<boolean>(IS_SERVER_TOKEN);
  readonly #router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.#isServer) {
      return true;
    } else {
      return this.#router.navigate(['not-found'], { replaceUrl: true });
    }
  }
}
